import {AdvancedSearchType} from './AdvancedSearchType';
import {DateRangeFilter} from './DateRangeFilter';
import {Pagination} from './Pagination';
import {SortDirection} from './SortDirection';

/**
 * @export
 * @type SavedSearchRequest
 */
export type SavedSearchRequest = {
    searchTypes?: Array<AdvancedSearchType>;
    /**
     * The name query to filter the saved searches.
     */
    nameQuery?: string;
    pagination: Pagination;
    createDateFilter?: DateRangeFilter;
    lastRunDateFilter?: DateRangeFilter;
    lastSharedDateFilter?: DateRangeFilter;
    sortDirection: SortDirection;
    sortField: SavedSearchRequestSortField;
}

export enum SavedSearchRequestSortField {
    NAME = 'NAME',
    CREATE_DATE = 'CREATE_DATE',
    LAST_RUN_DATE = 'LAST_RUN_DATE',
    LAST_SHARED_DATE = 'LAST_SHARED_DATE',
    SEARCH_TYPE = 'SEARCH_TYPE'
}